module.exports = __webpack_public_path__ + "media/V95.6661eea0.mp4";